import BridgeSigningView from './BridgeSigningView';

export default BridgeSigningView;



// WEBPACK FOOTER //
// ./src/views/bridgeSigning/index.js